import { useStyles } from '@webapps/styles';
import OpcoRecordSteps from './OpcoRecordSteps';
import SignedSteps from './SignedSteps';
import Informations from './Informations';
import BusinessInfo from './BusinessInfo';
import SchoolInfo from './SchoolInfo';
import { Divider } from '@material-ui/core';

const Overview = ({ opcoRecord, refetch, invalidCounts, totalInvalid, setTabValue, setOpenAddEmployerAccordion }) => {
  const { classes, css, cx, global } = useStyles(styles);

  // Fonction pour vérifier si au moins une condition d'information est présente
  const hasInformationToShow = () => {
    // Condition pour InformationSign
    const hasSignCondition = opcoRecord?.contract && !opcoRecord?.contract?.cfaSignAction && opcoRecord?.contract?.cfaSignAction != "SIGNED";

    // Condition pour InformationGenerate
    const hasGenerateCondition = opcoRecord?.opcoStatus === 'READY' && !opcoRecord?.contract;

    // Condition pour InformationSend
    const hasSendCondition = opcoRecord?.contract?.status === 'ARCHIVED' && opcoRecord?.opcoStatus === "PENDING";

    // Condition pour AlertMessage avec champs invalides
    const hasInvalidFieldsCondition = totalInvalid > 0;

    // Condition pour AlertMessage avec erreurs techniques
    const hasTechnicalErrorCondition = opcoRecord?.errors?.length > 0 && ["ERROR-CERFA-UPLOAD", "ERROR-CONTRACT-UPLOAD", "ERROR-CONVENTION-UPLOAD", "FORBIDDEN"].includes(opcoRecord?.opcoStatus);

    // Condition pour AlertMessage avec re-génération
    const hasRegenerateCondition = opcoRecord?.errors.length == 0 && ["ERROR-CERFA-UPLOAD", "ERROR-CONTRACT-UPLOAD", "ERROR-CONVENTION-UPLOAD", "FORBIDDEN"].includes(opcoRecord?.opcoStatus);

    return hasSignCondition || hasGenerateCondition || hasSendCondition || hasInvalidFieldsCondition || hasTechnicalErrorCondition || hasRegenerateCondition;
  };

  return (
    <div className={cx(global.fcjs, classes.gap)}>
      {hasInformationToShow() && (
        <>
          <Informations opcoRecord={opcoRecord} refetch={refetch} totalInvalid={totalInvalid} setTabValue={setTabValue} setOpenAddEmployerAccordion={setOpenAddEmployerAccordion} />
          <Divider />
        </>
      )}
      <SchoolInfo opcoRecord={opcoRecord} dataCompletion={invalidCounts?.training} />
      <Divider />
      <BusinessInfo opcoRecord={opcoRecord} dataCompletion={invalidCounts?.employer + invalidCounts?.master + invalidCounts?.contract} />
      <Divider />
      <SignedSteps opcoRecord={opcoRecord} dataCompletion={totalInvalid} />
      <Divider />
      <OpcoRecordSteps opcoRecord={opcoRecord} />
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  gap: {
    gap: 40,
  }
});

export default Overview;